






import { Vue, Component } from "../vue-ext";

@Component
export default class NotesView extends Vue {
    private created() {
        this.root.setTitle(this.$t("menu.notes") as string);
        this.root.setIconClass("icon-notes-white");
    }
}
